import React, { ReactNode } from 'react';

export const BodyTemplate = ({ children }: { children: ReactNode[] | ReactNode }): JSX.Element => (
  <>{children}</>
);
